var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5C12.5523 15.5 13 15.0523 13 14.5V9.50001C13 8.94772 12.5523 8.50001 12 8.50001C11.4477 8.50001 11 8.94772 11 9.50001V14.5C11 15.0523 11.4477 15.5 12 15.5Z",
    fill: "#F74F44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6738 18.0049L12.8688 6.06395C12.4852 5.39079 11.5148 5.39079 11.1312 6.06395L4.32621 18.0049C3.9463 18.6716 4.42773 19.5 5.19503 19.5H18.805C19.5723 19.5 20.0537 18.6716 19.6738 18.0049ZM14.6065 5.0737C13.4556 3.05421 10.5444 3.05421 9.39353 5.0737L2.58857 17.0147C1.44883 19.0146 2.89312 21.5 5.19503 21.5H18.805C21.1069 21.5 22.5512 19.0146 21.4114 17.0147L14.6065 5.0737Z",
    fill: "#F74F44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.5C13 18.0523 12.5523 18.5 12 18.5C11.4477 18.5 11 18.0523 11 17.5C11 16.9477 11.4477 16.5 12 16.5C12.5523 16.5 13 16.9477 13 17.5Z",
    fill: "#F74F44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9ef888587028fa856de417c1834b2f7a.svg";
export { ForwardRef as ReactComponent };